import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, IconButton, Link, useTheme, useMediaQuery } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { Facebook, Instagram, PinDrop } from "@mui/icons-material";
import { fetchSystemData, getTopCategoriesForMenu } from "../services/apiCalls";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [systemData, setSystemData] = useState({
    name: "",
    address: "",
    phone: "",
    email: "",
    logo: "",
    fbLink: "",
    instaLink: "",
  });
  const [menus, setmenus] = useState([]);
  const navigate = useNavigate();

  const footerLinks = [
    { name: "Return Policy", path: "#" },
    { name: "Privacy Policy", path: "#" },
    { name: "Terms of Service", path: "/terms" },
    { name: "FAQ", path: "/faq" },
  ];

  const footerUsefulLinks = [
    { name: "Contact Us", path: "/contact" },
    { name: "Track Order", path: "/profile#orders" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchSystemData();
        setSystemData({
          name: data?.name || "Company Name",
          address: data.address,
          phone: data?.phone || "+1 (234) 567-890",
          email: data?.email || "info@example.com",
          logo: data?.logo,
          fbLink: data?.fb_link,
          instaLink: data?.inst_link,
        });
      } catch (error) {
        console.error("Failed to fetch system data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchCategoriesMenu = async () => {
      try {
        const response = await getTopCategoriesForMenu();
        setmenus(response.data);
      } catch (error) {
        console.error("Error fetching top categories:", error);
      }
    };

    if (menus.length === 0) {
      fetchCategoriesMenu();
    }

    return () => { };
  }, []);

  return (
    <Box sx={{ backgroundColor: "#fff", color: "#233", padding: "40px 0" }}>
      <Grid container spacing={4}>
        {/* About Us */}
        <Grid
          className="hidden sm:block"
          item
          xs={12}
          md={3}
          sx={{
            position: "relative",
            "&::before": {
              content: "''",
              width: "1px",
              height: "calc(100% - 40px)",
              backgroundColor: "#e6e6e6",
              position: "absolute",
              top: "20px",
              right: "-10px",
            },
          }}
        >
          <Typography mb={"1.4em"} fontWeight={"600"} fontSize={"20px"}>
            Know Us
          </Typography>
          <Grid gap={"1.7em"} display={"flex"} flexDirection={"column"}>
            {menus.map((item, index) => (
              <RouterLink
                key={index}
                to={`/products/${item.id}`}
                color={"inherit"}
                underline="none"
              >
                <Typography fontSize={"16px"}>{item.name}</Typography>
              </RouterLink>
            ))}
          </Grid>
        </Grid>

        {/* Combined Company Details Grid */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
            "&::before": {
              content: "''",
              width: "1px",
              height: "calc(100% - 40px)",
              backgroundColor: "#e6e6e6",
              position: "absolute",
              top: "20px",
              right: "-10px",
            },
          }}
        >
          <Box mb={"3em"}>
            <img
              src={systemData.logo}
              alt="Logo"
              style={{ width: "100%", maxWidth: "180px" }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.4em",
            }}
          >

            <Typography variant="body1" align="center">
              <PinDrop sx={{ marginRight: "8px" }} />{systemData.address} <br />
              <EmailIcon sx={{ marginRight: "8px" }} />  {systemData.email}

              {isMobile && (
                <div>
                  <PhoneIcon sx={{ marginRight: "8px" }} /> {systemData.phone}
                </div>
              )}
              {!isMobile && (
                <>
                  <span className="ml-4 mr-4">|</span>
                  <PhoneIcon sx={{ marginRight: "8px" }} /> {systemData.phone}
                </>
              )}

            </Typography>
          </Box>

          <Grid gap={"1.7em"} display={"flex"} >
            {footerUsefulLinks.map((item, index) => (
              <Link
                key={index}
                onClick={() => navigate(item.path)}
                sx={{
                  cursor: "pointer",
                  // "&:hover": {
                  //   color: "#2189ff",
                  // },
                }}
                color={"inherit"}
                underline="none"
              >
                <Typography fontSize={"16px"}>{item.name}</Typography>

              </Link>
            ))}
          </Grid>

          <Box sx={{ mt: 1, display: "flex", justifyContent: "center" }}>
            {systemData.fbLink && (
              <IconButton
                sx={{ color: "#1e1e1e" }}
                aria-label="Facebook"
                href={systemData.fbLink}
                target="_blank"
              >
                <Facebook />
              </IconButton>
            )}
            {systemData.instaLink && (
              <IconButton
                sx={{ color: "#1e1e1e" }}
                aria-label="Instagram"
                href={systemData.instaLink}
                target="_blank"
              >
                <Instagram />
              </IconButton>
            )}
          </Box>
        </Grid>


        {/* Policy Information */}
        <Grid
          item
          xs={12}
          md={3}
        >
          <Typography mb={"1.4em"} fontWeight={"600"} fontSize={"20px"}>
            Policy Information
          </Typography>
          <Grid gap={"1.7em"} display={"flex"} flexDirection={"column"}>
            {footerLinks.map((item, index) => (
              <Link
                key={index}
                onClick={() => navigate(item.path)}
                sx={{
                  cursor: "pointer",
                  // "&:hover": {
                  //   color: "red",
                  // },
                }}
                color={"inherit"}
                underline="none"
              >
                <Typography fontSize={"16px"}>{item.name}</Typography>
              </Link>
            ))}
          </Grid>
        </Grid>
      </Grid>

      {/* <Grid container spacing={4}> */}

      {/* About Us */}
      {/* <Grid
          item
          xs={12}
          md={2.5}
          sx={{
            position: "relative",
            "&::before": {
              content: "''",
              width: "1px",
              height: "calc(100% - 40px)",
              backgroundColor: "#e6e6e6",
              position: "absolute",
              top: "20px",
              right: "-10px",
            },
          }}
        >
          <Typography mb={"1.4em"} fontWeight={"600"} fontSize={"20px"}>
            Know Us
          </Typography>
          <Grid gap={"1.7em"} display={"flex"} flexDirection={"column"}>
            {menus.map((item, index) => (
              <RouterLink
                key={index}
                to={`/products/${item.id}`}
                color={"inherit"}
                underline="none"
              >
                <Typography fontSize={"16px"}>{item.name}</Typography>
              </RouterLink>
            ))}
          </Grid>
        </Grid> */}

      {/* Combined Company Details Grid */}
      {/* <Grid item xs={12} md={3.5}>
          <Box mb={"3em"}>
            <img
              src={systemData.logo}
              alt="Logo"
              style={{ width: "100%", maxWidth: "180px" }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.4em",
            }}
          >
            <PinDrop sx={{ marginRight: "8px" }} />
            <Typography variant="body1">{systemData.address}</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.4em",
            }}
          >
            <PhoneIcon sx={{ marginRight: "8px" }} />
            <Typography variant="body1">{systemData.phone}</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.4em",
            }}
          >
            <EmailIcon sx={{ marginRight: "8px" }} />
            <Typography variant="body1">{systemData.email}</Typography>
          </Box>
        </Grid> */}

      {/* Policy Information */}
      {/* <Grid
          item
          xs={12}
          md={3}
          sx={{
            position: "relative",
            "&::before": {
              content: "''",
              width: "1px",
              height: "calc(100% - 40px)",
              backgroundColor: "#e6e6e6",
              position: "absolute",
              top: "20px",
              right: "-10px",
            },
          }}
        >
          <Typography mb={"1.4em"} fontWeight={"600"} fontSize={"20px"}>
            Policy Information
          </Typography>
          <Grid gap={"1.7em"} display={"flex"} flexDirection={"column"}>
            {footerLinks.map((item, index) => (
              <Link
                key={index}
                onClick={() => navigate(item.path)}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    color: "#2189ff",
                  },
                }}
                color={"inherit"}
                underline="none"
              >
                <Typography fontSize={"16px"}>{item.name}</Typography>
              </Link>
            ))}
          </Grid>
        </Grid>
      </Grid> */}

      {/* Useful Links */}
      {/* <Grid
        item
        xs={12}
        md={2.5}
        sx={{
          position: "relative",
          "&::before": {
            content: "''",
            width: "1px",
            height: "calc(100% - 40px)",
            backgroundColor: "#e6e6e6",
            position: "absolute",
            top: "20px",
            right: "-10px",
          },
        }}
      >
        <Typography mb={"1.4em"} fontWeight={"600"} fontSize={"20px"}>
          Useful Links
        </Typography>
        <Grid gap={"1.7em"} display={"flex"} flexDirection={"column"}>
          <Grid gap={"1.7em"} display={"flex"} flexDirection={"column"}>
            {footerUsefulLinks.map((item, index) => (
              <Link
                key={index}
                onClick={() => navigate(item.path)}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    color: "#2189ff",
                  },
                }}
                color={"inherit"}
                underline="none"
              >
                <Typography fontSize={"16px"}>{item.name}</Typography>
              </Link>
            ))}
          </Grid>
        </Grid>
      </Grid> */}

      {/* <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-start" }}>
        {systemData.fbLink && (
          <IconButton
            sx={{ color: "#1e1e1e" }}
            aria-label="Facebook"
            href={systemData.fbLink}
            target="_blank"
          >
            <Facebook />
          </IconButton>
        )}
        {systemData.instaLink && (
          <IconButton
            sx={{ color: "#1e1e1e" }}
            aria-label="Instagram"
            href={systemData.instaLink}
            target="_blank"
          >
            <Instagram />
          </IconButton>
        )}
      </Box> */}
    </Box>
  );
};

export default Footer;
